angular.module('app').component('summarySearchCriteria', {
    bindings: {
        searchDto: '<' // IsearchDto
    },
    controllerAs: 'vm',
    controller: function (SearchParamsService) {
        let vm = this;
        vm.isVisible = isVisible;
        vm.reset = reset;
        let searchDto;
        this.$onInit = function () {
            searchDto = SearchParamsService.getSearchDto();
            vm.searchDto = searchDto;
            if (!searchDto) {
                vm.searchDto = null;
            }
        };
        this.$onChanges = function (changes) {
            if (!changes.searchDto.currentValue) {
                return;
            }
            searchDto = this.searchDto;
            vm.searchDto = searchDto;
            vm.searchDate = moment(searchDto.searchDate).format('DD/MMM/YYYY');
            vm.searchDateTo = moment(searchDto.searchDateTo).format('DD/MMM/YYYY');
        };
        function reset() {
            SearchParamsService.reset();
            vm.searchDto = null;
        }
        function isVisible() {
            return vm.searchDto !== null;
        }
    },
    template: `
<div class="col-md-4" ng-if="vm.isVisible()">
    <div class="panel panel-primary my-child box-shadow--4dp">
        <div class="panel-heading">
            <span class="panel-title">Search Criteria</span>
        </div>
        <div class="panel-body">

            <div>
                <i class="glyphicon glyphicon-user space-right"></i>
                {{vm.searchDto.searchTester}}
            </div>
            <div>
                <i class="glyphicon glyphicon-transfer space-right"></i>
                {{vm.searchDto.searchSim}}
            </div>
            <div>
                <i class="glyphicon glyphicon-tags space-right"></i>
                {{vm.searchDto.searchSuite}}
            </div>
            <div>
                <i class="glyphicon glyphicon-flash space-right"></i>
                <span popover-trigger="'mouseenter'" popover-placement="auto" popover-append-to-body="true" uib-popover-template="'summary-search-criteria-popover.html'">
                    {{vm.searchDto.searchTruncatedTest}}
                </span>
            </div>
            <div ng-if="vm.searchDto.searchDate != null">
                <i class="glyphicon glyphicon-calendar space-right"></i>
                {{vm.searchDate}} to {{vm.searchDateTo}}
            </div>
            <div ng-if="vm.searchDto.traceSummaryRequest.ConnectedUser.IsSupport && !vm.searchDto.traceSummaryRequest.OverTheShoulder && vm.searchDto.TerminalId != null && vm.searchDto.TerminalId != ''">
                <i class="fa fa-terminal space-right"></i>
                Bit 41: {{vm.searchDto.TerminalId}}
            </div>
            <div ng-if="vm.searchDto.traceSummaryRequest.ConnectedUser.IsSupport && !vm.searchDto.traceSummaryRequest.OverTheShoulder && vm.searchDto.MerchantId != null && vm.searchDto.MerchantId != ''">
                <i class="fa fa-terminal space-right"></i>
                Bit 42: {{vm.searchDto.MerchantId}}
            </div>
            <div ng-if="vm.searchDto.advancedQuery">
                <i class="glyphicon glyphicon-search space-right"></i>
                {{vm.searchDto.advancedQuery}}
            </div>
            <div ng-if="vm.searchDto.failedVerdictsOnly">
                <i class="glyphicon glyphicon-remove space-right"></i>
                Failed Verdicts Only - {{vm.searchDto.failedVerdictsOnly}}
            </div>
            <div ng-if="vm.searchDto.rawMessagesOnly">
                <!--&lt;&#47;&gt; = </> in escaped chars-->
                <strong>&lt;&#47;&gt;</strong>
                Raw Messages Only - {{vm.searchDto.rawMessagesOnly}}
            </div>
        </div>
    </div>
</div>

<script type="text/ng-template" id="summary-search-criteria-popover.html">
    <span class="popover-white-space-wrap">{{vm.searchDto.searchTest}}</span>
</script>
`
});
